(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/expanded-statistics-widget/assets/javascripts/expanded-statistics-widget.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/expanded-statistics-widget/assets/javascripts/expanded-statistics-widget.js');
"use strict";


const {
  getBetradarId
} = svs.components.oddset.kambiOffering;
const logger = new svs.core.log.Logger('components:oddset-kambi:expanded-statistics-widget');
const widgetEvents = svs.oddset_kambi.components.widgetEvents;
const {
  sportradarMatchUrl
} = svs.oddset_kambi.data;
class ExpandedStatisticsWidget extends HTMLElement {
  static get observedAttributes() {
    return ['args'];
  }
  get args() {
    return this.getAttribute('args');
  }
  async connectedCallback() {
    let betRadarId;
    try {
      var _JSON$parse;
      const eventId = (_JSON$parse = JSON.parse(this.args)) === null || _JSON$parse === void 0 || (_JSON$parse = _JSON$parse.context) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.eventId;
      betRadarId = await getBetradarId(eventId);
      if (!betRadarId) {
        logger.warn("Missing betRadarId for event ".concat(eventId));
        betRadarId = -1; 
      }
    } catch (error) {
      logger.error('Something went wrong while getting betRadarId. Error:', JSON.stringify(error));
      return;
    }
    if (!sportradarMatchUrl) {
      logger.error('sportradarMatchUrl is not defined');
      return;
    }
    const css = "\n      button {\n        border: none;\n        background: #676161;\n        color: white;\n        width: 100%;\n        padding: 10px;\n        border-radius: 4px;\n        font-family: inherit;\n        font-size: inherit;\n        cursor: pointer;\n      }\n    ";
    const shadowRoot = this.attachShadow({
      mode: 'open'
    });
    const button = document.createElement('button');
    button.setAttribute('role', 'button');
    button.setAttribute('aria-label', 'Visa utökad statistik');
    button.innerHTML = 'Utökad statistik';
    button.addEventListener('click', () => {
      widgetEvents.openExpandedStatistics(betRadarId);
    });
    shadowRoot.innerHTML = "<style>".concat(css, "</style>");
    shadowRoot.appendChild(button);
  }
}
customElements.define('expanded-statistics-widget', ExpandedStatisticsWidget);

 })(window);